export default "__VITE_ASSET__BsCzPzw$__"